var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:( _obj = { 'input-checkbox': true, 'is-slim': _vm.slim }, _obj[("is-" + _vm.type)] = true, _obj )},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":_vm.change}}),_c('span')])
var _obj;}
var staticRenderFns = []

export { render, staticRenderFns }